import { Avatar, Button, Card, Col, Divider, Drawer, Empty, Form, Input, message, Modal, Popover, Row, Select, Slider, Space, Spin, Switch, Tabs, Tooltip, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useReducer, useState } from 'react';
import { BarcodeOutlined, DeleteOutlined, InfoOutlined, LeftOutlined, MinusOutlined, PlusOutlined, ReloadOutlined, SettingOutlined } from '@ant-design/icons';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
// import * as d3 from 'd3';
// import Plot from 'react-plotly.js';
import { useAuth } from '../Context';
import Plot from 'react-plotly.js';
import { WATERFALL_EVENTS_DATA, WATERFALL_EVENTS_DATA_ERROR, WATERFALL_EVENTS_DATA_SUCCESS, WATERFALL_EVENTS_UPDATE, WATERFALL_EVENTS_UPDATE_ERROR, WATERFALL_EVENTS_UPDATE_SUCCESS, WATERFALL_GRAPH, WATERFALL_GRAPH_CONFIG, WATERFALL_PIPELINE_CONFIG_DATA, WATERFALL_PIPELINE_CONFIG_DATA_ERROR, WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS } from './constants';
import waterfallData1 from './reducer';
// import moment from 'moment';
import eventsicons from '../eventstypes';
import axios from 'axios';
import signBoard from '../../images/sign-board.png';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import TabPane from 'antd/es/tabs/TabPane';
// import wellicon from '../../images/oil-well.png';

const { Title } = Typography;

export default function WaterFall () {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	// const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	// const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	// const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	// const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));

	const { getAllEvents, eventsData, getPids, pidsData, handleGetMapdata, mapdata  } = useAuth();
	// const { state } = useLocation();

	// const [websocketdasdata, setWebsocketDASData] =useState({});
	const [spin, setSpin] = useState(false);
	const [depthRangeFrom, setDepthRangeFrom] = useState(null);
	const [depthRangeTo, setDepthRangeTo] = useState(null);
	const [pidsId, setPidsId] = useState();
	const [dassocketurl, setDasSocketUrl] = useState(null);
	const [dasSocket, setDasSocket] = useState();
	const[clickableData, setClickableData] = useState();
	const [isDataModalOpen, setIsDataModalOpen] = useState(false);
	const [channelAndPidsData, setChannelAndPidsData] = useState();
	const [selectdActivity, setSelectedActivity] = useState();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [drawerDepthFrom, setDrawerDepthFrom] = useState();
	const [drawerDepthTo, setDrawerDepthTo] = useState();

	const [depthFrom, setDepthFrom] = useState(null);
	const [depthTo, setDepthTo] = useState(null);

	const [zMin, setZMin] = useState(0);
	const [zMax, setZMax] = useState();
	const [zoomDistance, setZoomdistance] = useState(100);
	const [opendrawer, setIsDrawerOpen] = useState(false);
	const [eventconfidencejson, setEventConfidenceJson] = useState({id:[], waterfallEventConfidenceCap:[]});
	const [suppressionUpdateValues, setSuppressionUpdateValues] = useState([{ Start: '', End: '' }]);	

	const navigate = useNavigate();

	const initalState = {graphData:[], loading: false, error: false, piplineGroups : [] };
	const [waterfall, dispatch] = useReducer(waterfallData1, initalState);	

	const pidsListFilter = [];

	let tempPidId;
	let tempPidurl;

	let tempstartDepth;
	let tempendDepth;

	const minPipelineChainage =  waterfall?.piplineGroups?.startendChainage?.minChainage || 0;
	const maxPipelineChainage = waterfall?.piplineGroups?.startendChainage?.maxChainage || 0;
	
	useEffect(() => {		
		setDepthRangeFrom(minPipelineChainage);
		setDepthRangeTo(maxPipelineChainage);
		setDepthFrom(minPipelineChainage);
		setDepthTo(maxPipelineChainage);
		setDrawerDepthFrom(minPipelineChainage);
		setDrawerDepthTo(maxPipelineChainage);
		setZoomdistance(waterfall?.graphConfig?.zoomDistance || 100);
		setZMin(waterfall?.graphConfig?.magThresholds?.minThreshold || 0);
		setZMax(waterfall?.graphConfig?.magThresholds?.maxThreshold || 20);

	},[minPipelineChainage, maxPipelineChainage]);	
	
	let socketDAS = null;

	const trueAndFalse = [
		{value: true, label: langdata && langdata.Yes ? langdata.Yes : 'Yes'},
		{value: false, label: langdata && langdata.No ? langdata.No : 'No'}
	];

	const allevents = [];
	eventsData && eventsData.map((item) => {
		allevents.push({
			value : item.id,
			label: item.eventType
		});
	});

	const sortedPidsData = Array.isArray(pidsData)
		? [...pidsData].sort((a, b) => a.id - b.id)
		: [];		

	sortedPidsData && sortedPidsData.map((item,index) => {
		
		if(item){
			pidsListFilter.push({
				value : item.id,
				label : item.name.toUpperCase(),

				dasip: item && item.waterfallip ,
				dasport : item && item.waterfallport,

				dasSocketurl : item && item.waterfallSocketurl,
				dasSocketurlEnabled: item && item.waterfallSocketurlEnabled,
			});
			if (index === 0) {			
				tempPidId = item.id;
				tempPidurl = item && item.waterfallSocketurlEnabled ? `wss://${item && item.waterfallSocketurl}` : `ws://${item && item.waterfallip}:${item && item.waterfallport}`;

			}

		}
	});

	let pipelineChainage = [];
	
	mapdata &&  mapdata.map((item)=>{

		pipelineChainage.push({
			value:item.pipelineChainage,
			label:item.pipelineChainage.toString()
		});
	});

	useEffect(() => {
		// setdasEnabled(dasEnabled1);
		setDepthRangeFrom(tempstartDepth);
		setDepthRangeTo(tempendDepth);
	},[tempstartDepth, tempendDepth]);

	useEffect(() => {
		getPids(authtoken);
	},[]);

	useEffect(() => {
		getAllEvents(authtoken);
		// getPipelineConfig(authtoken, pidsId ? pidsId : tempPidId ? tempPidId : null, null);

		const pidsinfoIdparams=`pidsinfoId=${pidsId ? pidsId : tempPidId ? tempPidId : null}`;

		dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA });
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/primarypipelineconfiginfo?${pidsinfoIdparams}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
		
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS, payload : response.data});
				}else {
					dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	},[tempPidId, pidsId]);

	
	
	
	const webSocketDataDAS = () =>{
		
		// const socket1 = new WebSocket(dassocketurl ? dassocketurl : tempPidurl); // Replace with your WebSocket URL
		// socket1.close();
		try {
			if(socketDAS == null) {
				socketDAS = new WebSocket(dassocketurl ? dassocketurl : tempPidurl); // Replace with your WebSocket URL
				setSpin(true);		
				setDasSocket(socketDAS);
				socketDAS.onopen = () => {
					console.log('WebSocket connection opened');
					setSpin(true);
				};
	
				socketDAS.onmessage = (event) => {
					try {
						const newData = JSON.parse(event.data);
				
						// setWebsocketDASData(newData);
						dispatch({ type : WATERFALL_GRAPH, payload : newData });
						setSpin(false);
	
					} catch (error) {

						setSpin(false);
						console.error('Error parsing data:', error);
					}
				};
	
				socketDAS.onerror = (error) => {
					setSpin(false);
					console.error('WebSocket error:', error);
				};
	
				socketDAS.onclose = () => {
					// setTimeout(setSpin(false), 5000);	
					// setTimeout(()=> {
					// 	webSocketDataDAS();
					// }, 10000);	
					setSpin(false);
					dispatch({ type : WATERFALL_GRAPH, payload : [] });
					console.log('WebSocket connection closed');
				};		
	
				const handlePopState = () => {			
					socketDAS.close();
					dispatch({ type : WATERFALL_GRAPH, payload : [] });
				};

				const handleUrlChange = () => {
					if (socketDAS) {
						socketDAS.close();
						dispatch({ type : WATERFALL_GRAPH, payload : [] });
					}
				};
		
				window.addEventListener('popstate', handlePopState);

				const originalPushState = history.pushState;
				const originalReplaceState = history.replaceState;

				history.pushState = function (...args) {
					originalPushState.apply(this, args);
					handleUrlChange(); // Close socket on push
				};

				history.replaceState = function (...args) {
					originalReplaceState.apply(this, args);
					handleUrlChange(); // Close socket on replace
				};
		
				return () => {
					window.removeEventListener('popstate', handlePopState);
					socketDAS.close();
					dispatch({ type : WATERFALL_GRAPH, payload : [] });
					history.pushState = originalPushState; // Restore original pushState
					history.replaceState = originalReplaceState; // Restore original replaceState
				};
			}
		} catch (error) {
			setSpin(false);
			console.error('WebSocket error:', error);
			dispatch({ type : WATERFALL_GRAPH, payload : [] });
			message.config({
				duration : 5,
				maxCount : 1,
			});
			message.open({
				type: 'error',
				content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
			});
			navigate('/connection-error');
		}
	};	

	useEffect(() => {

		if(dassocketurl || tempPidurl){						

			webSocketDataDAS();
		}
	
	}, [tempPidurl, dassocketurl]);
	
	
	const handleSetPids = (e , options) =>{				

		tempPidId=e;
		setPidsId(e);
		// setWebsocketDASData([]);
		if(dasSocket){
			dasSocket.close();
		}
		
		if(options.dasSocketurlEnabled){
			setDasSocketUrl(`wss://${options.dasSocketurl}`);

		}else{

			setDasSocketUrl(`ws://${options.dasip}:${options.dasport}`);
		}

		
	};
	

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);	

	// const transpose = (matrix) => matrix && matrix[0] ? matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex])) : matrix;
			
	const bandPassPlotData = [{
		// z: transpose(waterfall && waterfall.graphData && waterfall.graphData.data),
		z: waterfall && waterfall.graphData && waterfall.graphData.data,
		y: waterfall && waterfall.graphData && waterfall.graphData.times,
		x: waterfall && waterfall.graphData && waterfall.graphData.depths,
		colorscale: 'Jet',
		type: 'heatmap',
		zmin: zMin, // <-- set your new minimum value for color scale
		zmax: zMax, // <-- set your new maximum value for color scale
		// reversescale:true,
		hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Time ?? 'Time'} : %{y} <br> ${langdata?.Amplitude ?? 'Amplitude'} : %{z} <extra></extra>`,

		colorbar: {x: 1,   thickness: 10,
			// thicknessmode: 'pixels',
			// lenmode: 'fraction',
			outlinewidth: 0},
		orientation: '',

	}];	

	const bandPassLayout = {
		// title: 'Flow Monitoring',
		title : false,
		fontWeight: 800,
		autosize: true,
		yaxis: { title: langdata && langdata.Time ? langdata.Time : 'Time', type : 'date'  },
		xaxis: { 
			title: langdata && langdata.Distancem ? langdata.Distancem : 'Distance (m)', 
			// autorange: 'reversed',  
			range: depthRangeFrom || depthRangeFrom == 0 && depthRangeTo  || depthRangeTo == 0 ? [depthRangeFrom, depthRangeTo ] : [ tempstartDepth, tempendDepth ],
			tick0: null,           // Start the ticks at 0 (adjust as needed)
			dtick:  null,
			minor: {
				ticks: 'outside', // Show minor ticks
				ticklen: 5,      // Length of minor ticks
				showgrid: false,
				// dtick: (xMax - xMin) / 10 // 10 minor ticks between main ticks
			}
		},
		height: 0,
		dragmode: 'select',
		// paper_bgcolor: 'rgba(0,0,0,0)',
		plot_bgcolor: 'rgba(0,0,0,0)',
		margin: {t: 10, b: 40 },
		// paper_bgcolor: 'transparent', // Remove background color of the entire chart
		// plot_bgcolor: 'transparent'   // Remove background color of the plot area
	};

	const event_markers = [];
	let eventData = 'Machine Digging';
	eventsicons && eventsicons.map((icondata)=>{
		if(icondata.type === eventData) {				
			event_markers.push([ icondata.severity[3]]);
	
		}
	});

	const markerLayout = {
		title: false,
		fontWeight: 800,
		autosize: true,
		yaxis: { 
			title: langdata && langdata.Magnitude ? langdata.Magnitude : 'Magnitude',
			range: zMin || zMin == 0 &&  zMax || zMax == 0 ? [zMin,zMax] : [0, 5], // Start y-axis from 0
			fixedrange: true,
			dtick: false, // Set tick interval as needed
			showticklabels: true, // Show y-axis tick labels
			ticks: 'outside',     // Show y-axis tick marks
			showline: true,       // Show y-axis line
			zeroline: false,
			showgrid: false,       // Show y-axis grid lines if desired
		},
		xaxis: { 
			title: langdata && langdata.Distancem ? langdata.Distancem : 'Distance (m)',
			range: depthRangeFrom || depthRangeFrom == 0 && depthRangeTo  || depthRangeTo == 0
				? [depthRangeFrom, depthRangeTo]
				: [tempstartDepth, tempendDepth],
			tick0: null,
			dtick: null, // Or set a value for regular intervals
			showticklabels: true, // Show x-axis tick labels
			ticks: 'outside',     // Show x-axis tick marks
			showline: true,       // Show x-axis line
			zeroline: false,
			showgrid: false,       // Show x-axis grid lines if desired
			minor: {
				ticks: 'outside', // Show minor ticks
				ticklen: 5,      // Length of minor ticks
				showgrid: false,
				// dtick: (xMax - xMin) / 10 // 10 minor ticks between main ticks
			}
		},
		height: 0,
		dragmode: 'select',
		margin: { t: 20},
		images: [],
		// paper_bgcolor: 'rgba(0,0,0,0)',
		// plot_bgcolor: 'rgba(0,0,0,0)',
	};
	
	waterfall?.piplineGroups?.primaryChainagesarray && waterfall?.piplineGroups?.primaryChainagesarray.map((item) => {
		markerLayout.images.push(
			{
				source: signBoard,
				x: item,     // X position of the image
				y: zMin > 0 ? (zMin/1.5)+(zMax/5) : zMin + (zMax/5),     // Y position of the image
				xref: 'x',
				yref: 'y',
				sizex: (depthRangeFrom - depthRangeTo) / 50,  // Adjust image size
				sizey: 30,
				xanchor: 'center',
				yanchor: 'middle',
				layer: 'above',
			}
		);
	});
	
	const hoverTextArray = [];
	for (const i in waterfall && waterfall.graphData && waterfall.graphData.anomaly_type) {
		eventsicons && eventsicons.map((icondata)=>{
			
			if(icondata.type === waterfall.graphData.anomaly_type[i]) {				
				// event_markers.push([ icondata.severity[3]]);
				
				markerLayout.images.push(
					{
						source: icondata.severity[3],
						x: waterfall.graphData.anomaly_depths[i],     // X position of the image
						y: zMin > 0 ? (zMin/1.5)+(zMax/6) : zMin + (zMax/6),       // Y position of the image
						xref: 'x',
						yref: 'y',
						sizex: (depthRangeFrom - depthRangeTo) / 70,  // Adjust image size
						sizey: 30,
						xanchor: 'center',
						yanchor: 'middle',
						layer: 'above',
					}				
				);

				hoverTextArray.push(
					`Event: ${waterfall.graphData.anomaly_type[i]}<br>Chainage: ${waterfall.graphData.anomaly_depths[i]}`
				);
			}
		});
	}	
	
	
	const terrainCircleTrace = [{
		x: waterfall?.piplineGroups?.groupedterrainChainagearray ? waterfall?.piplineGroups?.groupedterrainChainagearray : [],
		y: Array.isArray(waterfall?.piplineGroups?.groupedterrainChainagearray) ? Array(waterfall?.piplineGroups?.groupedterrainChainagearray.length).fill(zMin) : [],
		mode: 'markers',
		marker: {
			color: 'rgba(135, 206, 250, 0.5)',
			size: 20,
			line: {
				color: 'MediumPurple',
				width: 2
			},
		},
		name: 'Terrain',
		hoverinfo: 'text',
		hovertext: waterfall?.piplineGroups?.groupIdChainageinfoArray,
		showlegend: false,
	}];		

	terrainCircleTrace.push({
		x: waterfall && waterfall.graphData && waterfall.graphData.anomaly_depths ? waterfall.graphData.anomaly_depths : [],
		y: Array.isArray(waterfall && waterfall.graphData && waterfall.graphData.anomaly_depths) ? Array(waterfall && waterfall.graphData && waterfall.graphData.anomaly_depths.length).fill(zMin + 1) : [],
		mode: 'markers',
		marker: {
			color: 'rgba(0,0,0,0)',
			size: 40
		},
		hovertext: hoverTextArray,
		hoverinfo: 'text',
		showlegend: false
	});

	terrainCircleTrace.push({
		x: waterfall?.piplineGroups?.primaryChainagesarray ? waterfall?.piplineGroups?.primaryChainagesarray : [],
		y: Array.isArray(waterfall?.piplineGroups?.primaryChainagesarray) ? Array(waterfall?.piplineGroups?.primaryChainagesarray.length).fill(zMin) : [],
		mode: 'markers',
		marker: {
			color: 'rgba(0,0,0,0)',
			size: 40
		},
		hovertext: waterfall?.piplineGroups?.primayChainageinfoArray ? waterfall?.piplineGroups?.primayChainageinfoArray : [],
		hoverinfo: 'text',
		showlegend: false
	});

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const handleRangefrom = (e) => {				
		if(e.target.value) {
			setDepthRangeFrom(parseInt(e.target.value));

		} else {
			setDepthRangeFrom();
		}
	};

	const handleRangeTo = (e) => {
		// if(e.target.value && e.target.value >= depthRangeFrom) {
		// 	setDepthRangeTo(e.target.value);

		// } else {
		// 	message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
		// 	setDepthRangeTo(depthTo);
		// }

		if(e.target.value && e.target.value >= depthFrom && e.target.value <= depthTo){
			if(e.target.value && e.target.value >= depthRangeFrom) {
				setDepthRangeTo(parseInt(e.target.value));	

			} else {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				setDepthRangeTo();
			}
		}else{
			message.warning(langdata && langdata.Maxvaluescannotbegreaterthantheentirelength ? langdata.Maxvaluescannotbegreaterthantheentirelength : 'Max values cannot be greater than the entire length.');
			setDepthRangeTo(depthTo);
		}
	};		

	const handleScalefrom = (e) => {				
		if(e.target.value) {
			setZMin(parseInt(e.target.value));

		} else {
			setZMin();
		}
	};

	const handleScaleTo = (e) => {
		if(e.target.value) {
			if(e.target.value > zMin) {
				if(e.target.value > 100) {
					message.warning(langdata && langdata.MaxValuecannotbegreaterthan100 ? langdata.MaxValuecannotbegreaterthan100 : 'Max value cannot be greater than 100.');
					return false;
				}
				setZMax(e.target.value);
			}else {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
			}

		} else {
			setZMax();
		}
	};	
	
	const handleWaterfallSelect = (value) => {
		if(value?.range){
			const from = Math.round(value.range.x[0]);
			const to = Math.round(value.range.x[1]);
			setDepthRangeFrom(from);
			setDepthRangeTo(to);
		}
	};
	
	const hansleResetDepth = () => {
		setDepthRangeFrom(minPipelineChainage);
		setDepthRangeTo(maxPipelineChainage);
		setDrawerDepthFrom(minPipelineChainage);
		setDrawerDepthTo(maxPipelineChainage);
		setDepthFrom(minPipelineChainage);
		setDepthTo(maxPipelineChainage);
	};	
	
	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.waterfallcontent ? langdata.waterfallcontent :  'This module displays live visualization data from various PIDS. It includes predicted events detected across the system, along with a graphical representation of PIDS-allocated pipelines. Each Icon shows detailed information about detected events and chainage info.'}</p>
		</Card>
	);

	const handleZoomIn = () => {
		if((depthRangeFrom + zoomDistance) < (depthRangeTo - zoomDistance)){
			setDepthRangeFrom(depthRangeFrom + zoomDistance);
			setDepthRangeTo(depthRangeTo - zoomDistance);
		}
	};

	const handleZoomOut = () => {
		if((depthRangeFrom > minPipelineChainage) && (depthRangeTo <= maxPipelineChainage)){
			setDepthRangeFrom(depthRangeFrom - zoomDistance);
			setDepthRangeTo(depthRangeTo + zoomDistance);
		}
	};

	const handleClick = (value) => {
		setClickableData( value.points[0]);
		setIsDataModalOpen(true);
		setChannelAndPidsData({
			channel_id : waterfall && waterfall.graphData && waterfall.graphData.channel_id,
			channel_name : waterfall && waterfall.graphData && waterfall.graphData.channel_name,
			pids_id : waterfall && waterfall.graphData && waterfall.graphData.pids_id,
			pids_name : waterfall && waterfall.graphData && waterfall.graphData.pids_name,
		});		
	};

	const waterfallGraphConfig = () => {

		let params = '';		
		if(pidsId || tempPidId) {
			params += `pidsinfoId=${pidsId ? pidsId : tempPidId}`;
			
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/waterfallconfig?${params}`,
				headers: { 
					Authorization:`Bearer ${authtoken}`	
				}
			};
			
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {
						dispatch({ type : WATERFALL_GRAPH_CONFIG, payload : response.data });
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
		}
	};


	useEffect(() => {
		waterfallGraphConfig();
	},[pidsId, tempPidId]);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues : {
			id : waterfall.graphConfig && waterfall.graphConfig.id,
			pidsinfoId : waterfall.graphConfig && waterfall.graphConfig.pidsinfoId,
			minMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.minThreshold,
			maxMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.maxThreshold,
			minAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.minThreshold,
			maxAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.maxThreshold,
			minAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.minThreshold,
			maxAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.maxThreshold,
			magThresholdsOverride : waterfall.graphConfig && waterfall.graphConfig.magThresholdsOverride,
			ampSNThresholdsOverride : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholdsOverride,
			ampFreqThresholdsOverride : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholdsOverride,
			defaultminMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.defaultminThreshold,
			defaultmaxMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.defaultmaxThreshold,
			defaultminAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.defaultminThreshold,
			defaultmaxAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.defaultmaxThreshold,
			defaultminAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.defaultminThreshold,
			defaultmaxAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.defaultmaxThreshold,
			zoomDistance: waterfall.graphConfig && waterfall.graphConfig.zoomDistance ? waterfall.graphConfig.zoomDistance : 100,
			FPS : waterfall.graphConfig && waterfall.graphConfig.FPS ? waterfall.graphConfig.FPS : 10,
			sampleRate : waterfall.graphConfig && waterfall.graphConfig.sampleRate ? waterfall.graphConfig.sampleRate : 100,
			isLogging: waterfall.graphConfig && waterfall.graphConfig.isLogging ? waterfall.graphConfig.isLogging : false,
			deviceName: waterfall.graphConfig && waterfall.graphConfig.deviceName ? waterfall.graphConfig.deviceName : '',
			directory: waterfall.graphConfig && waterfall.graphConfig.directory ? waterfall.graphConfig.directory : '',
			fileName: waterfall.graphConfig && waterfall.graphConfig.fileName ? waterfall.graphConfig.fileName : '',
			suppressions: waterfall.graphConfig && waterfall.graphConfig.suppressions ? waterfall.graphConfig.suppressions : null,
		},
		onSubmit: () => {			
				
			const id = parseInt(formik.values.id);
			const start = [];
			const end = [];
			if(!suppressionUpdateValues || suppressionUpdateValues.length > 0 && suppressionUpdateValues.some((input) => input.Start === '' || input.End === '')) {
				Modal.warning({title : langdata && langdata.Pleasefillallsuppressionfields ? langdata.Pleasefillallsuppressionfields : 'Please fill all suppression fields'});
				return false;
			}
			if(formik.values.minMagThreshold > formik.values.maxMagThreshold) {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				return false;
			}

			suppressionUpdateValues && suppressionUpdateValues.map((input) => {
				start.push(input.Start);
				end.push(input.End);
			});
			
			let data = JSON.stringify({
				'magThresholds': {
					'maxThreshold': formik.values.maxMagThreshold,
					'minThreshold': formik.values.minMagThreshold,
					'defaultmaxThreshold': formik.values.defaultmaxMagThreshold,
					'defaultminThreshold': formik.values.defaultminMagThreshold
				},
				'magThresholdsOverride': formik.values.magThresholdsOverride ,
				'ampFreqThresholds': {
					'maxThreshold': formik.values.maxAmpFreqThresholds,
					'minThreshold': formik.values.minAmpFreqThresholds,
					'defaultmaxThreshold': formik.values.defaultmaxAmpFreqThresholds,
					'defaultminThreshold': formik.values.defaultminAmpFreqThresholds
				},
				'ampFreqThresholdsOverride': formik.values.ampFreqThresholdsOverride ,
				'ampSNThresholds': {
					'maxThreshold': formik.values.maxAmpSNThresholds,
					'minThreshold': formik.values.minAmpSNThresholds,
					'defaultmaxThreshold': formik.values.defaultmaxAmpSNThresholds,
					'defaultminThreshold': formik.values.defaultminAmpSNThresholds
				},
				'ampSNThresholdsOverride': formik.values.ampSNThresholdsOverride ,
				'zoomDistance': parseInt(formik.values.zoomDistance),
				'FPS': parseInt(formik.values.FPS),
				'sampleRate': parseInt(formik.values.sampleRate),
				'isLogging': formik.values.isLogging,
				'directory': formik.values.directory,
				'deviceName': formik.values.deviceName,
				'fileName': formik.values.fileName,
				'suppressions': {
					'end': end,
					'start': start
				},
			});
	
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/waterfallconfig/${id}`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`	
				},
				data : data
			};
	
			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						waterfallGraphConfig();
						Modal.success({ title: langdata && langdata.Graphdetailssuccessfullyupdated ? langdata.Graphdetailssuccessfullyupdated : 'Graph details successfully updated.' });
						setIsModalOpen(false);
						setDepthRangeFrom(drawerDepthFrom);
						setDepthRangeTo(drawerDepthTo);
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoupdategraphdetails ? langdata.Unabletoupdategraphdetails : 'Unable to update graph details' });
	
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoupdategraphdetails ? langdata.Unabletoupdategraphdetails : 'Unable to update graph details' });
					}
				});
		}
	});

	const depthMarks = {
		[depthFrom ? depthFrom : tempstartDepth] : langdata && langdata.Min ? langdata.Min : 'Min',
		[depthTo ? depthTo : tempendDepth] :langdata && langdata.Max ? langdata.Max : 'Max', 
		// [drawerDepthFrom] : {style:{marginTop: '-35px',  display:'flex'}, label: <span>{drawerDepthFrom}</span>},
		// [drawerDepthTo] : {style:{marginTop: '-35px',  display:'flex'}, label: <span>{drawerDepthTo}</span>},
	};	

	const ampMarks = {
		0: langdata && langdata.Min ? langdata.Min : 'Min',
		20000 : langdata && langdata.Max ? langdata.Max : 'Max',
		// [formik.values.ampThresholdsOverride == true ? formik.values.minAmpThreshold :  formik.values.defaultminAmpThreshold] : {style:{marginTop: '-35px',  display:'flex'}, label: <span>{formik.values.ampThresholdsOverride == true ? formik.values.minAmpThreshold :  formik.values.defaultminAmpThreshold}</span>},
		// [formik.values.ampThresholdsOverride == true ? formik.values.maxAmpThreshold : formik.values.defaultmaxAmpThreshold] : {style:{marginTop: '-35px',  display:'flex'}, label: <span>{formik.values.ampThresholdsOverride == true ? formik.values.maxAmpThreshold : formik.values.defaultmaxAmpThreshold}</span>}
	};		

	
	const dasFrequencyMarks = {
		0: langdata && langdata.Min ? langdata.Min : 'Min',
		20000 : langdata && langdata.Max ? langdata.Max : 'Max',
		// [formik.values.ampFreqThresholdsOverride == true ? formik.values.minAmpFreqThresholds : formik.values.defaultminAmpFreqThresholds] : {style:{marginTop: '-35px',  display:'flex'}, label: <span>{formik.values.ampFreqThresholdsOverride == true ? formik.values.minAmpFreqThresholds : formik.values.defaultminAmpFreqThresholds}</span>} ,
		// [formik.values.ampFreqThresholdsOverride == true ? formik.values.maxAmpFreqThresholds : formik.values.defaultmaxAmpFreqThresholds] : {style:{marginTop: '-35px',  display:'flex'}, label: <span>{formik.values.ampFreqThresholdsOverride == true ? formik.values.maxAmpFreqThresholds : formik.values.defaultmaxAmpFreqThresholds}</span>}
	};

	const handleOk = () => {
		setIsDataModalOpen(false);
		// formik.resetForm();
		setIsModalOpen(false);
		formik.resetForm();
	};
	const handleCancel = () => {
		setIsDataModalOpen(false);
		// formik.resetForm();
		setIsModalOpen(false);
		formik.resetForm();
	};

	const handleSelectEvent = (value) => {
		setSelectedActivity(value);
	};

	const handleNavigateSimulation = () => {
		navigate(( '/add-simulations'),{ state: {time : clickableData && clickableData.y, depth : Math.trunc(clickableData && clickableData.x ), 
			activity : selectdActivity, channelAndPidsData : channelAndPidsData} });
	};

	const showModal = () => {
		setIsModalOpen(true);
	};

	const showDrawer = () => {
		handleGetMapdata(authtoken);
		setIsDrawerOpen(true);
		getWaterfallevents();
		const startArr =  formik?.values?.suppressions?.start || [];
		const endArr = formik?.values?.suppressions?.end || [];
		const result = startArr.map((startValue, idx) => ({
			Start: startValue,
			End: endArr[idx]
		}));
		setSuppressionUpdateValues(result);
	};


	const getWaterfallevents = () => {

		dispatch({ type : WATERFALL_EVENTS_DATA});
		let params = '';		
		params += 'isWaterfallEvent=true';
			
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/allevents?${params}`,
			headers: { 
				Authorization:`Bearer ${authtoken}`	
			}
		};
			
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : WATERFALL_EVENTS_DATA_SUCCESS, payload : response.data });
				}
				else{
					dispatch({ type : WATERFALL_EVENTS_DATA_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : WATERFALL_EVENTS_DATA_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};

	const handleReset = () => {
		formik.resetForm();
		setDepthRangeFrom(minPipelineChainage);
		setDepthRangeTo(maxPipelineChainage);
		setDrawerDepthFrom(minPipelineChainage);
		setDrawerDepthTo(maxPipelineChainage);
		setDepthFrom(minPipelineChainage);
		setDepthTo(maxPipelineChainage);
	};
	
	const handleDepthChange = (value) => {
		// setDrawerDepthFrom(value[0]);
		if(parseInt(value[0]) <= depthTo){
			setDrawerDepthFrom(parseInt(value[0]));
			setDrawerDepthTo(drawerDepthTo ? drawerDepthTo : depthRangeTo);
		}else{
			message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
			setDrawerDepthFrom();
		}
		// setDrawerDepthTo(value[1]);
		if(parseInt(value[1]) >= depthFrom && parseInt(value[1]) <= depthTo){
			if(value[1] && value[1] >= drawerDepthFrom) {
				setDrawerDepthTo(parseInt(value[1]));	
				// setDrawerDepthFrom(drawerDepthFrom ? drawerDepthFrom : depthRangeFrom);

			} else {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				setDrawerDepthTo();
			}
		}else{
			message.warning(langdata && langdata.Maxvaluescannotbegreaterthantheentirelength ? langdata.Maxvaluescannotbegreaterthantheentirelength : 'Max values cannot be greater than the entire length.');
			setDrawerDepthTo();
		}
	};

	const handleInputDepthRangefrom = (e) => {
		// const startDepth = depthFrom ? depthFrom : tempstartDepth;
		// const endDepth = depthTo ? depthTo : tempendDepth;
		if(e.target.value && e.target.value <= depthTo){
			setDrawerDepthFrom(parseInt(e.target.value));
			setDrawerDepthTo(drawerDepthTo ? drawerDepthTo : depthRangeTo);
		}else{
			message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
			setDrawerDepthFrom();
		}
	};

	const handleInputDepthRangeTo = (e) => {
		// const startDepth = depthFrom ? depthFrom : tempstartDepth;
		// const endDepth = depthTo ? depthTo : tempendDepth;
		if(e.target.value && e.target.value >= depthFrom && e.target.value <= depthTo){
			if(e.target.value && e.target.value >= drawerDepthFrom) {
				setDrawerDepthTo(parseInt(e.target.value));	
				setDrawerDepthFrom(drawerDepthFrom ? drawerDepthFrom : depthRangeFrom);

			} else {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				setDrawerDepthTo();
			}
		}else{
			message.warning(langdata && langdata.Maxvaluescannotbegreaterthantheentirelength ? langdata.Maxvaluescannotbegreaterthantheentirelength : 'Max values cannot be greater than the entire length.');
			setDrawerDepthTo(depthTo);
		}
		// }
	};

	const onClose = () => {
		setIsDrawerOpen(false);
		setEventConfidenceJson({id:[], waterfallEventConfidenceCap:[]});
		// setSuppressionUpdateValues([{ Start: '', End: '' }]);
	};

	const handleConfidenceChange =(item, e) => {
		
		let ids = Array.isArray(eventconfidencejson.id) ? [...eventconfidencejson.id] : [];
		let caps = Array.isArray(eventconfidencejson.waterfallEventConfidenceCap) ? [...eventconfidencejson.waterfallEventConfidenceCap] : [];

		const idx = ids.indexOf(item.id);
		if (idx !== -1) {
			caps[idx] = e.target.value;
		} else {
			ids.push(item.id);
			caps.push(e.target.value);
		}

		setEventConfidenceJson({
			...eventconfidencejson,	
			id: ids,
			waterfallEventConfidenceCap: caps
		});
	};

	const handleApplyConfidence = () => {

		dispatch({ type : WATERFALL_EVENTS_UPDATE });
		let data = {
			'id' :eventconfidencejson.id,
			'waterfallEventConfidenceCap' : eventconfidencejson.waterfallEventConfidenceCap
		};		
		
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/bulkupdate-allevents`,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : data
		};
		
		axios.request(config)
			.then((response) => {
				if ( response.status === 200 || response.status === 201 || response.status === 204 ) {
					dispatch({ type : WATERFALL_EVENTS_UPDATE_SUCCESS});
					getWaterfallevents();
					Modal.success({ title: langdata && langdata.Eventconfidenceupdatedsuccessfully ? langdata.Eventconfidenceupdatedsuccessfully : 'Event confidence updated successfully.' });
				}else {
					dispatch ({ type :WATERFALL_EVENTS_UPDATE_ERROR });
					Modal.error({ title: langdata && langdata.Failedtoupdateeventconfidence ? langdata.Failedtoupdateeventconfidence : 'Failed to update event confidence.' });
				}
			})
			.catch((error) => {
				dispatch ({ type : WATERFALL_EVENTS_UPDATE_ERROR });
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
		
	};

	const handleUpdateChangeSuppression = (index, field, value) => {
		const newSuppressionValues = [...suppressionUpdateValues];
		newSuppressionValues[index][field] = value;
		setSuppressionUpdateValues(newSuppressionValues);
	};

	const handleUpdateAddSuppression = () => {
		setSuppressionUpdateValues([...suppressionUpdateValues, { Start: '', End: '' }]);
	};

	const handleUpdateDeleteSuppression = (index) => {
		setSuppressionUpdateValues(suppressionUpdateValues.filter((_, i) => i !== index));
	};

	useEffect(() => {
		const startArr =  formik?.values?.suppressions?.start || [];
		const endArr = formik?.values?.suppressions?.end || [];
		const result = startArr.map((startValue, idx) => ({
			Start: startValue,
			End: endArr[idx]
		}));
		setSuppressionUpdateValues(result);
	},[formik?.values?.suppressions]);
		

	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={5}>
						<Row>
							<Space>
								<BarcodeOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							{/* <Col style={{marginLeft:'4px'}} span={19}> */}
							<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.Waterfall ? langdata.Waterfall : 'Waterfall'}</Title>
							<Space>&nbsp;&nbsp;</Space>
						</Row>
					</Col>
					<Col span={19}>
						<Row justify="end">
							<Col>
								<Tooltip placement="bottom" title={langdata && langdata.Filterbypids ? langdata.Filterbypids:'Filter by pids'}>
									<Space>
										<Select Item
											showSearch
											filterOption={filterOption}
											style={{ minWidth: '200px', maxWidth:'200px', margin:'5px'}}
											placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS:'Select PIDS'}
											optionFilterProp="children"
											// defaultValue={pidsId}
											options={pidsListFilter}
											value={pidsId ? pidsId : tempPidId}
											// onSelect={(e)=>setPidsId(e)}
											onSelect={(e, options)=>handleSetPids(e, options)}
										/>
									</Space>
								</Tooltip>
								
								{/* <Tooltip placement="bottom" title={langdata && langdata.EnterDepthRange ? langdata.EnterDepthRange:'Enter Depth Range'}>
									<Space.Compact size="middle" style={{ width : '240px', margin:'5px'}}>
										<Input type='number'  value={depthRangeFrom} placeholder={langdata && langdata.DepthRangeFrom ? langdata.DepthRangeFrom: 'Depth Range From'} onChange={handleRangefrom} />
										<Input type='number'  value={depthRangeTo} placeholder={langdata && langdata.DepthRangeTo ? langdata.DepthRangeTo: 'Depth Range To'} onChange={handleRangeTo}/>
									</Space.Compact>
								</Tooltip> */}
								{/* <Space>&nbsp;</Space> */}
								{/* <Tooltip placement="bottom" title={langdata && langdata.ResetDepthRange ? langdata.ResetDepthRange:'Reset Depth Range'}>
									<Button type="primary" icon={<ReloadOutlined />} size={'middle'} onClick={hansleResetDepth}/>
								</Tooltip> */}
								<Space>&nbsp;</Space>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.GraphConfigurations ? langdata.GraphConfigurations: 'Graph Configurations'}>
										<Button style ={{margin:'5px'}} type='primary' onClick={showModal} icon={<SettingOutlined size="small" />}/>
									</Tooltip>
								</Space>
								<Space>&nbsp;</Space>
								<Popover title={langdata.Waterfall ? langdata.Waterfall : 'Waterfall' }  content={infoContent} trigger="click">
									<Avatar size="small"><InfoOutlined /></Avatar>
								</Popover>
								<Space>&nbsp;</Space>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.DataTransformation ? langdata.DataTransformation:'Data Transformation'}>
										<Button style ={{margin:'5px'}} type='primary' onClick={showDrawer} icon={<LeftOutlined size="small" />}/>
									</Tooltip>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>		


				{dassocketurl || tempPidurl ? 
					<>
						<Col span={24} style={{padding:'10px'}}>
							<Row style={{ backgroundColor : 'white', marginBottom : '10px'}}>
								<Col span={12} style={{marginTop:'0px', fontSize : '10px'}}
									className="waterfall" >
									<b style={{fontSize : '12px'}}>{langdata && langdata.CurrentlyViewing ? langdata.CurrentlyViewing : 'Currently Viewing'}</b>
									<p style={{ marginTop : '5px'}}>  {langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} : {waterfall && waterfall.graphData && waterfall.graphData.channel_name} </p>
								</Col>
								{/* <Col  xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 6 }} xs={{ span: 7 }}  style={{marginTop:'5px', fontSize : '10px'}}
									className="waterfall" >
									{langdata && langdata.DateandTime ? langdata.DateandTime : 'Date and Time'} : {moment().format(settingsdateformat + ' ' + settingstimeformat)} <br />
								</Col>
								<Col  xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 6 }} xs={{ span: 7 }} style={{marginTop:'5px', fontSize : '10px'}}
									className="waterfall" >
									{langdata && langdata.EventName ? langdata.EventName : 'Event Name'} : {'Machine Digging'} <br />
								</Col> */}
								<Col  span={12} style={{marginTop:'5px',fontSize : '10px', display : 'flex', justifyContent : 'flex-end'}}>
									<Tooltip placement="bottom" title={langdata && langdata.EnterScaleRange ? langdata.EnterScaleRange:'Enter Scale Range'}>
										<Space.Compact size="small" style={{ width : '130px', margin:'15px'}}>
											<Input type='number' disabled value={zMin} placeholder={langdata && langdata.ScaleRangeFrom ? langdata.ScaleRangeFrom: 'Scale Range From'} onChange={handleScalefrom} />
											<Input type='number' max={50} step={.1}  value={zMax} placeholder={langdata && langdata.ScaleRangeTo ? langdata.ScaleRangeTo: 'Scale Range To'} onChange={handleScaleTo}/>
										</Space.Compact>
									</Tooltip>
									{/* <Space>&nbsp;&nbsp;</Space> */}
									
									<Tooltip placement="bottom" title={langdata && langdata.EnterDistanceRange ? langdata.EnterDistanceRange:'Enter Distance Range'}>
										<Space.Compact size="small" style={{ width : '240px', margin:'15px'}}>
											<Input type='number'  value={depthRangeFrom} placeholder={langdata && langdata.DepthRangeFrom ? langdata.DepthRangeFrom: 'Depth Range From'} onChange={handleRangefrom} />
											<Input type='number'  value={depthRangeTo} placeholder={langdata && langdata.DepthRangeTo ? langdata.DepthRangeTo: 'Depth Range To'} onChange={handleRangeTo}/>
										</Space.Compact>
									</Tooltip>
									
								</Col>
								{/* <Col  span={6} style={{marginTop:'5px',fontSize : '10px', display : 'flex', justifyContent : 'flex-end'}}> */}
								{/* <Space>&nbsp;&nbsp;</Space> */}
								{/* </Col> */}
							</Row>
							<Row justify='end'>

								<Col span={24} className='zoomInfo' style={{ display : 'flex', justifyContent : 'flex-end', marginRight : '20px', width : 'auto'}}>
									<Tooltip placement="bottom" title={langdata && langdata.ResetDistanceRange ? langdata.ResetDistanceRange:'Reset Distance Range'}>
										<Button type="primary" icon={<ReloadOutlined />} onClick={hansleResetDepth} size='small' />
									</Tooltip>
								</Col>

								<Col span={24} className='zoomInfo' style={{ display : 'flex', justifyContent : 'flex-end', marginRight : '20px', marginTop : '40px', width : 'auto'}}>
									<Tooltip placement="bottom" title={langdata && langdata.ZoomIn ? langdata.ZoomIn:'Zoom In'}>
										<Button 
											// style={{ margin:'15px', marginLeft : '0px'}} 
											type="primary" 
											icon={<PlusOutlined />} 
											onClick={handleZoomIn}
											size='small' />
									</Tooltip>
								</Col>
								<Col span={24} className='zoomInfo' style={{ display : 'flex', justifyContent : 'flex-end', marginRight : '20px', marginTop : '80px', width : 'auto'}}>
									<Tooltip placement="bottom" title={langdata && langdata.ZoomOut ? langdata.ZoomOut:'Zoom Out'}>
										<Button 
											// style={{ margin:'15px', marginLeft : '0px'}} 
											type="primary" 
											icon={<MinusOutlined />} 
											onClick={handleZoomOut}
											size='small' />
									</Tooltip>
								</Col>
							</Row>
							<Col>
								<Plot
									data={terrainCircleTrace}
									layout={ markerLayout}
									style={{ width: '100%', height: '200px', marginTop : '-25px' }}
									onSelected={(event) => {
										handleWaterfallSelect(event);
									}}
									config={{ 
										responsive: true,
										// displayModeBar: true,
										displaylogo : false,
										modeBarButtonsToRemove: [
											'pan2d',
											'zoom2d',
											'zoomIn2d',
											'zoomOut2d',
											'autoScale2d',
											'resetScale2d',
											'hoverClosestCartesian',
											'hoverCompareCartesian',
											'zoom3d',
											'pan3d',
											'resetViews3d',
											'hoverClosest3d',
											'hoverCompare3d',
											'orbitRotation',
											'tableRotation',
											'resetCameraDefault3d',
											'resetCameraLastSave3d',
										],
	
									}}
								/>
							</Col>
							<Col>
								<Plot
									data={bandPassPlotData}
									layout={ bandPassLayout}
									style={{ width: '100%', height: '650px', marginTop : '-25px' }}
									onSelected={(event) => {
										handleWaterfallSelect(event);
									}}
									onClick={(value) => {handleClick(value);}}
									config={{ 
										responsive: true,
										// displayModeBar: true,
										displaylogo : false,
										modeBarButtonsToRemove: [
											'pan2d',
											'zoom2d',
											'zoomIn2d',
											'zoomOut2d',
											'autoScale2d',
											'resetScale2d',
											'hoverClosestCartesian',
											'hoverCompareCartesian',
											'zoom3d',
											'pan3d',
											'resetViews3d',
											'hoverClosest3d',
											'hoverCompare3d',
											'orbitRotation',
											'tableRotation',
											'resetCameraDefault3d',
											'resetCameraLastSave3d',
										],
	
									}}
								/>
							</Col>
						</Col>
					</>
							
					: 
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						// paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>							
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						</Col>
					</Row>
				}

				<Modal
					title={langdata && langdata.SaveforTraining ? langdata.SaveforTraining : 'Save for Training'}
					open={isDataModalOpen} 
					onOk={handleOk} 
					onCancel={handleCancel}
					maskClosable={false}
					footer={[
						<Space key ='options'>
							<Button style={{ margin : '5px'}} onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
							<Button  type="primary" onClick={handleNavigateSimulation} style={{ margin : '5px'}} >{langdata && langdata.NEXT ? langdata.NEXT : 'NEXT'}</Button>
						</Space>
					]}
					// width={600}
				>
					<Row gutter={24}>
						<Col span={24}>
							{/* <Form.Item label={langdata && langdata.Time ? langdata.Time :  'Time'} >
													<Input value={dtsClickableData && dtsClickableData.x} disabled/>
												</Form.Item> */}
							<b>{langdata && langdata.Time ? langdata.Time :  'Time'} : </b>{clickableData && clickableData.x}
						</Col>
						<Col span={24} style={{ marginTop : '5px'}}>
							{/* <Form.Item label={langdata && langdata.Depth ? langdata.Depth :  'Depth'} >
													<Input value={dtsClickableData && dtsClickableData.y} disabled/>
												</Form.Item> */}
							<b>{langdata && langdata.Distancem ? langdata.Distancem :  'Distance (m)'} : </b>{clickableData && clickableData.y}
						</Col>
						<Col span={24} style={{ marginTop : '5px'}}>
							{/* <Form.Item label={langdata && langdata.Temperature ? langdata.Temperature :  'Temperature' + ':'} >
													<Input value={dtsClickableData && dtsClickableData.z} disabled/>
												</Form.Item> */}
							<b>{langdata && langdata.Magnitude ? langdata.Magnitude :  'Magnitude'} : </b>{clickableData && clickableData.z}
						</Col>
						<Col span={24} style={{ marginTop : '10px'}}>
							<Form.Item label={langdata && langdata.Label ? langdata.Label :  'Label'} >
								<Select Item
									style={{ width: '360px'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectEvent ? langdata.SelectEvent :'Select Event'}
									optionFilterProp="children"
															
									// defaultValue={['all']}
									options={allevents}
									onSelect={(value, options) => {handleSelectEvent(options);}}
								/>
							</Form.Item>
						</Col>
					</Row>
				</Modal>


				<Modal
					title={langdata && langdata.GraphConfigurations ? langdata.GraphConfigurations: 'Graph Configurations' }
					open={isModalOpen} 
					onOk={handleOk} 
					onCancel={handleCancel}
					maskClosable={false}
					footer={[
						<>
							<Row style={{
								margin: '10px',
								paddingLeft: '10px',
								paddingRight: '10px',
								background: '#FFFFFF',
								alignItems: 'center',
								marginTop : '10px'
							}}
							>
								<Col span={8}>
									{/* <Row>
														<Space>
															<Button onClick={handleReset}>RESET</Button>
														</Space>
													</Row> */}
								</Col>
								<Col span={16}>
									<Row justify="end">
										<Col>
											{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
											<Space>
												<Button style={{ margin : '5px'}} onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
											</Space>
											<Space>&nbsp;</Space>
											<Space>
												<Button onClick={formik.handleSubmit} type="primary" style={{ margin : '5px'}} >{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
											</Space>
										</Col>
									</Row>
								</Col>
							</Row>
						</>
					]}
					width={1000}
				>		
					<Divider/>
					<Row gutter={24}>
						<Col span={23}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.DAS ? langdata.DAS:'DAS'}</b></Typography>
								
						</Col>
						<Col  justify="end"  span={1}>
							<Tooltip placement="bottom" title={langdata && langdata.Reset ? langdata.Reset : 'Reset'}>
								<Avatar size="small" style={{ backgroundColor : '#1677FF'}}>							
									<ReloadOutlined onClick={handleReset} />	
								</Avatar>
							</Tooltip>
						</Col>
					</Row>
					<>

						<Row gutter={24} >
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.Magnitude ? langdata.Magnitude: 'Magnitude'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Enterthemagnituderanges ? langdata.Enterthemagnituderanges:'Enter the magnitude ranges'}>
										<Input 
											type='number'
											step={.1} 
											max={50}
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.magThresholdsOverride == true ? false : true}
											value={formik.values.magThresholdsOverride == true ? formik.values.minMagThreshold :  formik.values.defaultminMagThreshold}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20) ? (formik.setFieldValue('minMagThreshold', e.target.value), setZMin(e.target.value)) : null;
											}}
										/>
										{' '} <span > -  </span>{' '}
										<Input  
											type='number'
											step={.1} 
											max={50}
											min={0}
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.magThresholdsOverride == true ? false : true}
											value={formik.values.magThresholdsOverride == true ? formik.values.maxMagThreshold : formik.values.defaultmaxMagThreshold}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20) ? (formik.setFieldValue('maxMagThreshold', e.target.value), setZMax(e.target.value)) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range 
									step={.1}
									max={50} 
									onChange={(value) => {formik.setFieldValue('minMagThreshold', value[0]);formik.setFieldValue('maxMagThreshold', value[1]);}} 
									marks={ampMarks} 
									disabled = {formik.values.magThresholdsOverride == true ? false : true}
									value={[formik.values.magThresholdsOverride == true ? formik.values.minMagThreshold :  formik.values.defaultminMagThreshold, formik.values.magThresholdsOverride == true ? formik.values.maxMagThreshold : formik.values.defaultmaxMagThreshold]}/>
							</Col>
							{/* <Col span={8}>
													<Typography style={{ marginTop : '15px'}}>{langdata && langdata.SNRatio ? langdata.SNRatio: 'S/N Ratio'}</Typography>
													<Slider 
														range 
														step={10} 
														max={20000} 
														onChange={(value) => {formik.setFieldValue('minAmpSNThresholds', value[0]);formik.setFieldValue('maxAmpSNThresholds', value[1]);}} 
														marks={dasSNRatioMarks}
														disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
														value={[formik.values.ampSNThresholdsOverride == true ? formik.values.minAmpSNThresholds : formik.values.defaultminAmpSNThresholds, formik.values.ampSNThresholdsOverride == true ? formik.values.maxAmpSNThresholds : formik.values.defaultmaxAmpSNThresholds]}/>
												</Col> */}
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.CutoffFrequencyHz ? langdata.CutoffFrequencyHz: 'Cutoff Frequency (Hz)'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Entercutofffrequencyrange ? langdata.Entercutofffrequencyrange:'Enter cutoff frequency range'}>
										<Input 
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
											value={formik.values.ampFreqThresholdsOverride == true ? formik.values.minAmpFreqThresholds : formik.values.defaultminAmpFreqThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('minAmpFreqThresholds', e.target.value) : null;
											}}
										/>
										{' '} <span > -  </span>{' '}
										<Input  
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
											value={formik.values.ampFreqThresholdsOverride == true ? formik.values.maxAmpFreqThresholds : formik.values.defaultmaxAmpFreqThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('maxAmpFreqThresholds', e.target.value) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={20000} 
									onChange={(value) => {formik.setFieldValue('minAmpFreqThresholds', value[0]);formik.setFieldValue('maxAmpFreqThresholds', value[1]);}} 
									marks={dasFrequencyMarks}
									disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
									value={[formik.values.ampFreqThresholdsOverride == true ? formik.values.minAmpFreqThresholds : formik.values.defaultminAmpFreqThresholds, formik.values.ampFreqThresholdsOverride == true ? formik.values.maxAmpFreqThresholds : formik.values.defaultmaxAmpFreqThresholds]}/>
							</Col>

							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.SNRatio ? langdata.SNRatio: 'S/N Ratio'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.EnterSNratiorange ? langdata.EnterSNratiorange:'Enter S/N ratio range'}>
										<Input 
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
											value={formik.values.ampSNThresholdsOverride == true ? formik.values.minAmpSNThresholds : formik.values.defaultminAmpSNThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('minAmpSNThresholds', e.target.value) : null;
											}}
										/>
										{' '} <span > -  </span>{' '}
										<Input  
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
											value={formik.values.ampSNThresholdsOverride == true ? formik.values.maxAmpSNThresholds : formik.values.defaultmaxAmpSNThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('maxAmpSNThresholds', e.target.value) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={20000} 
									onChange={(value) => {formik.setFieldValue('minAmpSNThresholds', value[0]);formik.setFieldValue('maxAmpSNThresholds', value[1]);}} 
									marks={dasFrequencyMarks}
									disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
									value={[formik.values.ampSNThresholdsOverride == true ? formik.values.minAmpSNThresholds : formik.values.defaultminAmpSNThresholds, formik.values.ampSNThresholdsOverride == true ? formik.values.maxAmpSNThresholds : formik.values.defaultmaxAmpSNThresholds]}/>
							</Col>


							<Col span={8}>
								<Row>
									<Space>
										<Tooltip  placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
											<Switch 
												size="small" 
												onClick={(value) => {formik.setFieldValue('magThresholdsOverride', value);}}
												checked={formik.values.magThresholdsOverride}/>
										</Tooltip>
									</Space>
								</Row>
							</Col>
							{/* <Col span={8}>
													<Row>
														<Space>
															<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
																<Switch 
																	size="small" 
																	onClick={(value) => {formik.setFieldValue('ampSNThresholdsOverride', value);}}
																	checked={formik.values.ampSNThresholdsOverride}/>
															</Tooltip>
														</Space>
													</Row>
												</Col> */}
							<Col span={8}>
								<Row>
									<Space>
										<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
											<Switch 
												size="small" 
												onClick={(value) => {formik.setFieldValue('ampFreqThresholdsOverride', value);}}
												checked={formik.values.ampFreqThresholdsOverride}/>
										</Tooltip>
									</Space>
								</Row>
							</Col>

							<Col span={8}>
								<Row>
									<Space>
										<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
											<Switch 
												size="small" 
												onClick={(value) => {formik.setFieldValue('ampSNThresholdsOverride', value);}}
												checked={formik.values.ampSNThresholdsOverride}/>
										</Tooltip>
									</Space>
								</Row>
							</Col>
						</Row>
						<Divider/>

						<Row gutter={24} >
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.FramesPerSecond ? langdata.FramesPerSecond: 'Frames Per Second'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.PleaseentertheFramesPerSecond ? langdata.PleaseentertheFramesPerSecond:'Please enter the Frames Per Second'}>
										<Input 
											type='number'
											style={{width : '40%', height  :'25px'}}
											// disabled = {formik.values.ampThresholdsOverride == true ? false : true}
											value={formik.values.FPS}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 240) ? formik.setFieldValue('FPS', e.target.value) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range 
									step={10} 
									max={240} 
									onChange={(value) => {formik.setFieldValue('FPS', value[1]);}} 
									marks={ampMarks} 
									// disabled = {formik.values.ampThresholdsOverride == true ? false : true}
									value={[0,formik.values.FPS]}/>
							</Col>
							{/* <Col span={8}>
													<Typography style={{ marginTop : '15px'}}>{langdata && langdata.SNRatio ? langdata.SNRatio: 'S/N Ratio'}</Typography>
													<Slider 
														range 
														step={10} 
														max={20000} 
														onChange={(value) => {formik.setFieldValue('minAmpSNThresholds', value[0]);formik.setFieldValue('maxAmpSNThresholds', value[1]);}} 
														marks={dasSNRatioMarks}
														disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
														value={[formik.values.ampSNThresholdsOverride == true ? formik.values.minAmpSNThresholds : formik.values.defaultminAmpSNThresholds, formik.values.ampSNThresholdsOverride == true ? formik.values.maxAmpSNThresholds : formik.values.defaultmaxAmpSNThresholds]}/>
												</Col> */}
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.ZoomDistancem ? langdata.ZoomDistancem: 'Zoom Distance (m)'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Pleaseenterthezoomdistance ? langdata.Pleaseenterthezoomdistance:'Please enter the zoom distance'}>
										<Input 
											type='number'
											style={{width : '40%', height  :'25px'}}
											// disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
											value={formik.values.zoomDistance}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 1000) ? (formik.setFieldValue('zoomDistance', e.target.value), setZoomdistance(e.target.value)) : null;
											}}
										/>
										
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={1000} 
									onChange={(value) => {formik.setFieldValue('zoomDistance', value[1]);setZoomdistance(value[1]);}} 
									marks={dasFrequencyMarks}
									// disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
									value={[0, formik.values.zoomDistance]}/>
							</Col>

							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.SampleRate ? langdata.SampleRate: 'Sample Rate (sps)'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate:'Please enter the sample rate'}>
										<Input 
											type='number'
											style={{width : '40%', height  :'25px'}}
											// disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
											value={formik.values.sampleRate}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 10000) ? formik.setFieldValue('sampleRate', e.target.value) : null;
											}}
										/>
										
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={10000} 
									onChange={(value) => {formik.setFieldValue('sampleRate', value[1]);}} 
									marks={dasFrequencyMarks}
									// disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
									value={[0, formik.values.sampleRate]}/>
							</Col>

						</Row>
						<Divider/>

					</>
					
					<Row gutter={24} >
						<Col span={24}>
							<Typography style={{ marginTop : '15px'}}>{langdata && langdata.Distancem ? langdata.Distancem  : 'Distance (m)'}&nbsp;&nbsp;&nbsp;
								<Tooltip placement="bottom" title={langdata && langdata.EnterDistanceRange ? langdata.EnterDistanceRange:'Enter Distance Range'}>
									<Input 
										type='number' 
										style={{width : '15%', height  :'25px'}}
										value={drawerDepthFrom}
										max={maxPipelineChainage} 
										min={minPipelineChainage} 
										placeholder={langdata && langdata.DepthRangeFrom ? langdata.DepthRangeFrom: 'Depth Range From'} 
										onChange={handleInputDepthRangefrom} 
										// onChange={handleRangefrom}
									/>
									{' '} <span > -  </span>{' '}
									<Input 
										type='number' 
										style={{width : '15%', height  :'25px'}}
										value={drawerDepthTo}
										defaultValue={depthTo}
										max={maxPipelineChainage} 
										min={minPipelineChainage} 
										placeholder={langdata && langdata.DepthRangeTo ? langdata.DepthRangeTo: 'Depth Range To'} 
										onChange={handleInputDepthRangeTo}
										// onChange={handleRangeTo}
									/>
								</Tooltip>
							</Typography>
							<Slider style={{marginTop:'20px'}} range max={maxPipelineChainage} onChange={handleDepthChange} marks={depthMarks} value={[drawerDepthFrom, drawerDepthTo ? drawerDepthTo : depthRangeTo]} />
						</Col>
					</Row>
				</Modal>

				<Drawer
					title={langdata && langdata.DataTransformation ? langdata.DataTransformation:'Data Transformation'}
					placement='right'
					closable={false}
					onClose={onClose}
					open={opendrawer}
					key='right'
				>	
					<>
						<Tabs defaultActiveKey="1" 
							// onChange={callback}
							style={{marginTop:'-15px'}}
						>
							<TabPane tab={langdata && langdata.Events ? langdata.Events:'Events'} key="1">
								<Row gutter={24}>
									{waterfall && waterfall.waterfallEvents && waterfall.waterfallEvents.map((item)=>(
										<>
											<Col key = {item.id} span={14}>
												<Typography style={{ marginTop : '15px'}}>
													{item.eventType}&nbsp;&nbsp;&nbsp;
												</Typography>
											</Col>
											<Col span={10}>
										
												<Tooltip placement="bottom" title={langdata && langdata.Pleaseentertheeventconfidencecap ? langdata.Pleaseentertheeventconfidencecap:'Please enter the event confidence cap'}>
													<Input 
														type='number'
														step="0.1"
														max='1'
														min='.1'  
														style={{width : '90%', height  :'25px', marginTop : '15px'}}
														defaultValue={item.waterfallEventConfidenceCap} 
														placeholder={langdata && langdata.EventConfidenceCap ? langdata.EventConfidenceCap: 'Event Confidence Cap'} 
														onChange={(e)=> {handleConfidenceChange(item,e);}}
													/>
												</Tooltip>
											</Col>
										</>

									))}
									<Col span={24} style={{ marginTop : '20px', display:'flex', justifyContent: 'center'}}>
										<Row gutter={24} style={{display:'flex', justifyContent: 'center'}}>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button onClick={onClose}>{langdata && langdata.Close ? langdata.Close:'Close'}</Button>
											</Col>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button type='primary' onClick={handleApplyConfidence}>{langdata && langdata.Apply ? langdata.Apply:'Apply'}</Button>
											</Col>
										</Row>
									</Col>
								</Row>
							</TabPane>

							<TabPane tab={langdata && langdata.DataManager ? langdata.DataManager:'Data Manager'} key="2">
								<Row gutter={24}>
									<>
										<Form>
											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata && langdata.LoggingStatus ? langdata.LoggingStatus : 'Logging Status'}
																</span>
															}
															rules={[{ required: true, message: langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }]} required>
													
														</Form.Item>
													</Col>
													<Col span={15}>
														<Select
															style={{ minWidth: '200px'}}
															showSearch
															// filterOption={filterOption}
															placeholder={ langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }
															optionFilterProp="children"
															options={trueAndFalse}
															onChange={(value) => formik.setFieldValue('isLogging', value)}
															value={formik.values.isLogging}
														/>
													</Col>
												</Row>
											</Col>

											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata && langdata.DeviceName ? langdata.DeviceName : 'Device Name'}
																</span>
															} 
															rules={[{ required: true, message: langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name' }]} required>
													
														</Form.Item>
													</Col>
													<Col span={15}>
														<Input 
															name="deviceName" 
															placeholder={langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name'}
															onChange={formik.handleChange} 
															value={formik.values.deviceName}
														/>
													</Col>
												</Row>
											</Col>

											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata && langdata.Directory ? langdata.Directory : 'Directory'}
																</span>
															} 
															rules={[{ required: true, message: langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory' }]} required>
														</Form.Item>
													</Col>
													<Col span={15}>
														<Tooltip placement="bottom" title={formik.values.directory}>

															<Input 
																name="directory" 
																placeholder={langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory'}
																onChange={formik.handleChange} 
																value={formik.values.directory}
															/>
														</Tooltip>
													</Col>
												</Row>
											</Col>

											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={langdata && langdata.FileName ? langdata.FileName : 'File Name'} 
															rules={[{ required: true, message: langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter file name' }]} required>
														</Form.Item>
													</Col>
													<Col span={15}>
														<Tooltip placement="bottom" title={formik.values.fileName}>
															<Input 
																name="fileName" 
																placeholder={langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter the file name'}
																onChange={formik.handleChange} 
																value={formik.values.fileName}
															/>
														</Tooltip>
													</Col>
												</Row>
											</Col>
											<Divider/>

											<Row gutter={24} style={{marginBottom:'10px'}}>
												<Col span={12}>
													<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Suppressions ? langdata.Suppressions:'Suppressions'}</b></Typography>
												</Col>
												<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
													<Button
														style={{margin:'5px'}} 
														type="primary" 
														icon={<PlusOutlined />}
														size='small'
														onClick={handleUpdateAddSuppression}
													/>
												</Col>
											</Row>

											{suppressionUpdateValues.map((input, index) => (					
						
												<Row gutter={24} key={index}>
													<Col span={11}>
														<Form.Item
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata?.Start || 'Start'}
																</span>
															}
															rules={[{ required: true, message: langdata && langdata.Pleaseselectavalidstartingchainage ? langdata.Pleaseselectavalidstartingchainage : 'Please select a valid starting chainage' }]} required
									
														>
															{/* <Input
										placeholder={langdata?.Pleaseselectthestartchainage || 'Please select the start chainage'}
										value={input.Start}
										onChange={e => handleChangeSuppression(index, 'Start', e.target.value)}
									/> */}
															<Select
																style={{ minWidth: '100px'}}
																showSearch
																filterOption={filterOption}
																placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
																optionFilterProp="children"
																options={pipelineChainage}
																allowClear
																value={input.Start || input.Start == 0 && input.Start !== '' ? input.Start : null}
																onChange={e => handleUpdateChangeSuppression(index, 'Start', e)}
															/>
														</Form.Item>
													</Col>
													<Col span={10}>
														<Form.Item
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata?.End || 'End'}
																</span>
															}
															rules={[{ required: true, message: langdata && langdata.Pleaseselectavalidendingchainage ? langdata.Pleaseselectavalidendingchainage : 'Please select a valid ending chainage' }]} required
									
														>
															<Select
																style={{ minWidth: '100px'}}
																showSearch
																filterOption={filterOption}
																placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
																optionFilterProp="children"
																options={pipelineChainage}
																allowClear
																value={input.End || input.End == 0  && input.Start !== '' ? input.End : null}
																onChange={e => handleUpdateChangeSuppression(index, 'End', e)}
															/>
														</Form.Item>
													</Col>
													<Col span={3} style={{ marginTop: '3px', textAlign: 'center' }}>
														<Button
															danger
															icon={<DeleteOutlined />}
															size='small'
															onClick={() => handleUpdateDeleteSuppression(index)}
															disabled={suppressionUpdateValues.length === 0}
														/>
													</Col>
												</Row>
											))}
										</Form>
										
									</>

									<Col span={24} style={{ marginTop : '20px', display:'flex', justifyContent: 'center'}}>
										<Row gutter={24} style={{display:'flex', justifyContent: 'center'}}>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button onClick={onClose}>{langdata && langdata.Close ? langdata.Close:'Close'}</Button>
											</Col>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button type='primary' onClick={formik.handleSubmit}>{langdata && langdata.Apply ? langdata.Apply:'Apply'}</Button>
											</Col>
										</Row>
									</Col>
								</Row>
							</TabPane>
						</Tabs>
					
					</>
				
				</Drawer>

			</Content>

			<Spin fullscreen spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`}/>
			
		</>
	);
}